import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/authContext';
import { projectDataClient } from '../../lib/connect/clients';
export const GROWTH_WORKSPACES_KEY = 'growth-workspaces';
/**
 * GRW-02 `ListGrowthWorkspaces`: one page of the Growth RFI-response or
 * Proposal list. The server decides which workspaces appear (membership, or
 * tenant-wide under FND-25 `list.tenant_wide`) and filters every row and
 * linked pursuit by read; the page shows only what it returns.
 */ export function useGrowthWorkspaces(args) {
    const { user } = useAuth();
    return useQuery({
        queryKey: [
            GROWTH_WORKSPACES_KEY,
            user?.tenant_id,
            args.kind,
            args.status,
            args.pageToken
        ],
        queryFn: ()=>projectDataClient.listGrowthWorkspaces({
                kind: args.kind,
                status: args.status,
                pageSize: 50,
                pageToken: args.pageToken
            }),
        enabled: (args.enabled ?? true) && !!user?.id,
        placeholderData: keepPreviousData,
        retry: false
    });
}
